import { createContext, useContext, useEffect, useRef } from 'react';

const FacebookPixelContext = createContext({ track: () => {} });

export const FacebookPixelProvider = ({ pixelId, children }) => {
   const isLoaded = useRef(false);

   useEffect(() => {
      if (!pixelId || isLoaded.current) return;
      // Inject the Facebook Pixel script
      !(function (f, b, e, v, n, t, s) {
         if (f.fbq) return;
         n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
         };
         if (!f._fbq) f._fbq = n;
         n.push = n;
         n.loaded = !0;
         n.version = '2.0';
         n.queue = [];
         t = b.createElement(e);
         t.async = !0;
         t.src = v;
         s = b.getElementsByTagName(e)[0];
         s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', pixelId);
      window.fbq('track', 'PageView');
      isLoaded.current = true;
   }, [pixelId]);

   const track = (event, params = {}) => {
      if (typeof window !== 'undefined' && window.fbq) {
         window.fbq('track', event, params);
      }
   };

   return <FacebookPixelContext.Provider value={{ track }}>{children}</FacebookPixelContext.Provider>;
};

export const useFacebookPixel = () => useContext(FacebookPixelContext);
